import extractErrorMessage from '../../../shared/utils/extractErrorMessage';
import { authClient } from '../../../shared/api/client';

const isOkStatus = (status) => status >= 200 && status < 300;

export const fetchTherapyOccurrenceRequests = async ({
  page = 1,
  limit = 10,
  search = null,
  status = null,
  pickupMethod = null,
}) => {
  try {
    let query = `?page=${page}&limit=${limit}`;
    if (search) query += `&search=${encodeURIComponent(search)}`;
    if (status) query += `&status=${encodeURIComponent(status)}`;
    if (pickupMethod) {
      const pickupMethods = (
        Array.isArray(pickupMethod) ? pickupMethod : [pickupMethod]
      ).filter(Boolean);
      if (pickupMethods.length) {
        query += `&pickupMethod=${pickupMethods
          .map((value) => encodeURIComponent(value))
          .join(',')}`;
      }
    }

    const response = await authClient.get(`/therapy-occurrence-requests${query}`);
    return {
      data: response.data,
      status: response.status,
      ok: isOkStatus(response.status),
      message: response.data?.message || null,
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Doslo je do greske pri dobavljanju zahteva za terapiju.'
    );
    return {
      data: null,
      status: error?.response?.status || null,
      ok: false,
      message,
    };
  }
};

export const updateTherapyOccurrenceRequestStatus = async (id, payload) => {
  try {
    const response = await authClient.put(
      `/therapy-occurrence-requests/status/${id}`,
      payload
    );
    return {
      data: response.data,
      status: response.status,
      ok: isOkStatus(response.status),
      message: response.data?.message || 'Status zahteva je azuriran.',
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Doslo je do greske pri azuriranju statusa zahteva.'
    );
    return {
      data: null,
      status: error?.response?.status || null,
      ok: false,
      message,
    };
  }
};

export const createTherapyOccurrenceRequest = async (payload) => {
  try {
    const response = await authClient.post('/therapy-occurrence-requests', payload);
    return {
      data: response.data,
      status: response.status,
      ok: isOkStatus(response.status),
      message: response.data?.message || 'Zahtev za terapiju je kreiran.',
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Doslo je do greske pri kreiranju zahteva za terapiju.'
    );
    return {
      data: null,
      status: error?.response?.status || null,
      ok: false,
      message,
    };
  }
};

// Broj novih (nevidjenih) zahteva za badge na "Zahtevi" u navigaciji.
export const fetchUnseenTherapyOccurrenceRequestsCount = async () => {
  try {
    const response = await authClient.get(
      '/therapy-occurrence-requests/unseen-count'
    );
    return {
      data: response.data,
      status: response.status,
      ok: isOkStatus(response.status),
      message: response.data?.message || null,
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Doslo je do greske pri dobavljanju broja novih zahteva.'
    );
    return {
      data: null,
      status: error?.response?.status || null,
      ok: false,
      message,
    };
  }
};

// Oznacava zahteve kao vidjene (prikazani su na stranici "Zahtevi").
// Odgovor nosi novi broj nevidjenih zahteva ({ count }).
export const markTherapyOccurrenceRequestsSeen = async (ids) => {
  try {
    const response = await authClient.put('/therapy-occurrence-requests/seen', {
      ids,
    });
    return {
      data: response.data,
      status: response.status,
      ok: isOkStatus(response.status),
      message: response.data?.message || null,
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Doslo je do greske pri oznacavanju zahteva kao vidjenih.'
    );
    return {
      data: null,
      status: error?.response?.status || null,
      ok: false,
      message,
    };
  }
};
